import firebase from 'firebase'
// firebase init goes here
const config = {
  apiKey: "AIzaSyDanahwQw1qdjrvLOLsLAuO3eTN03O08ac",
  authDomain: "what-did-i-wear-ios.firebaseapp.com",
  databaseURL: "https://what-did-i-wear-ios.firebaseio.com",
  projectId: "what-did-i-wear-ios",
  storageBucket: "what-did-i-wear-ios.appspot.com",
  messagingSenderId: "87874299542"
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.database()
const auth = firebase.auth()
const currentUser = auth.currentUser

// firebase collections
const users = db.ref('users');
const outfits = db.ref('outfits');
const articles = db.ref('articles');

export {
  db,
  auth,
  currentUser,
  users,
  outfits,
  articles
}
